import { getAddress } from '@ethersproject/address'
import { BigNumber } from '@ethersproject/bignumber'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { ChainId, CurrencyAmount, JSBI, Token, USD, ZERO } from 'sdk'
import { CurrencyLogo } from 'app/components/CurrencyLogo'
import { useKashiPair } from 'app/features/kashi/hooks'
import { easyAmount, formatNumber } from 'app/functions'
import { useCurrency } from 'app/hooks/Tokens'
import { useActiveWeb3React } from 'app/services/web3'
import { useTransactionAdder } from 'app/state/transactions/hooks'
import { useRouter } from 'next/router'
import React, { useState } from 'react'
import { Box, Text, Button, Heading } from '@chakra-ui/react'

import { PairType } from './enum'
import { usePendingSushi, useUserInfo } from './hooks'
import useMasterChef from './useMasterChef'
import usePendingReward from './usePendingReward'

// @ts-ignore TYPE NEEDS FIXING
const RewardRow = ({ value, symbol }) => {
  return (
    <Text>
      <span>{value} </span>
      {symbol}
    </Text>
    // <Typography weight={700} className="text-high-emphesis">
    //   {value}{' '}
    //   <Typography component="span" className="text-secondary">
    //     {symbol}
    //   </Typography>
    // </Typography>
  )
}

// @ts-ignore TYPE NEEDS FIXING
const InvestmentDetails = ({ farm }) => {
  const { i18n } = useLingui()
  const { chainId } = useActiveWeb3React()
  const { harvest } = useMasterChef(farm.chef)
  const router = useRouter()
  const addTransaction = useTransactionAdder()
  const kashiPair = useKashiPair(farm.pair.id)
  const [pendingTx, setPendingTx] = useState(false)
  const token0 = useCurrency(farm.pair.token0.id)
  const token1 = useCurrency(farm.pair.token1.id)

  const liquidityToken = new Token(
    // @ts-ignore TYPE NEEDS FIXING
    chainId,
    getAddress(farm.pair.id),
    farm.pair.type === PairType.KASHI ? Number(farm.pair.asset.decimals) : 18,
    farm.pair.symbol ?? farm.pair.type === PairType.KASHI ? 'KMP' : 'SLP',
    farm.pair.name
  )

  const stakedAmount = useUserInfo(farm, liquidityToken)

  const kashiAssetAmount =
    kashiPair &&
    stakedAmount &&
    easyAmount(
      BigNumber.from(stakedAmount.quotient.toString()).mulDiv(
        // @ts-ignore TYPE NEEDS FIXING
        kashiPair.currentAllAssets.value,
        // @ts-ignore TYPE NEEDS FIXING
        kashiPair.totalAsset.base
      ),
      // @ts-ignore TYPE NEEDS FIXING
      kashiPair.asset
    )

  const pendingSushi = usePendingSushi(farm)
  const pendingReward = usePendingReward(farm)

  // console.log('farm : ', farm)
  // console.log("pendingSushi : ",pendingSushi)
  // console.log("pendingReward : ",pendingReward)
  const positionFiatValue = CurrencyAmount.fromRawAmount(
    // @ts-ignore TYPE NEEDS FIXING
    USD[chainId],
    farm.pair.type === PairType.KASHI
      ? // @ts-ignore TYPE NEEDS FIXING
        kashiAssetAmount?.usdValue.toString() ?? ZERO
      : JSBI.BigInt(
          ((Number(stakedAmount?.toExact() ?? '0') * farm.pair.reserveUSD) / farm.pair.totalSupply)
            // @ts-ignore TYPE NEEDS FIXING
            .toFixed(USD[chainId].decimals)
            // @ts-ignore TYPE NEEDS FIXING
            .toBigNumber(USD[chainId].decimals)
        )
  )

  // @ts-ignore TYPE NEEDS FIXING
  const secondaryRewardOnly = [ChainId.FUSE].includes(chainId)

  const rewardValue = !secondaryRewardOnly
    ? (farm?.rewards?.[0]?.rewardPrice ?? 0) * Number(pendingSushi?.toExact() ?? 0) +
      (farm?.rewards?.[1]?.rewardPrice ?? 0) * Number(pendingReward ?? 0)
    : (farm?.rewards?.[0]?.rewardPrice ?? 0) * Number(pendingReward ?? 0)

  async function onHarvest() {
    setPendingTx(true)
    try {
      console.log('Doing Claim')
      const tx = await harvest(farm.id)
      addTransaction(tx, {
        summary: i18n._(t`Claim ${farm.pair.token0.name}/${farm.pair.token1.name}`),
      })
    } catch (error) {
      console.error(error)
    }
    setPendingTx(false)
  }

  return (
    <>
      <Box className="last_teb_panal">
        <Box className="your_diposit">
          <Heading as="h5">{i18n._(t`Your Deposits`)}</Heading>
          {[PairType.KASHI, PairType.SWAP].includes(farm.pair.type) && (
            <Box className="img_dipl_flx">
              {/*@ts-ignore TYPE NEEDS FIXING*/}
              {token0 && <CurrencyLogo currency={token0} size={18} />}
              {farm.pair.type === PairType.KASHI && (
                <RewardRow
                  symbol={token0?.symbol}
                  // @ts-ignore TYPE NEEDS FIXING
                  value={formatNumber(kashiAssetAmount?.value.toFixed(kashiPair.asset.tokenInfo.decimals) ?? 0)}
                />
              )}
              {farm.pair.type === PairType.SWAP && (
                <RewardRow
                  value={formatNumber(
                    (farm.pair.reserve0 * Number(stakedAmount?.toExact() ?? 0)) / farm.pair.totalSupply
                  )}
                  symbol={token0?.symbol}
                />
              )}
            </Box>
          )}
          {farm.pair.type === PairType.SWAP && (
            <Box className="img_dipl_flx">
              {token1 && <CurrencyLogo currency={token1} size={18} />}
              <RewardRow
                value={formatNumber(
                  (farm.pair.reserve1 * Number(stakedAmount?.toExact() ?? 0)) / farm.pair.totalSupply
                )}
                symbol={token1?.symbol}
              />
            </Box>
          )}
          <Box className="yor_rvrd_whit_box">
            <Box className="your_riwrd">
              <Heading as="h3">{i18n._(t`Your Rewards`)}</Heading>
              <Text>{formatNumber(rewardValue, true)}</Text>
            </Box>
            {farm?.rewards?.map((reward, i) => {
              return (
                <Box className="last_para_parent" key={i}>
                  <CurrencyLogo currency={reward.currency} size={18} />
                  {!secondaryRewardOnly ? (
                    <>
                      {i === 0 && (
                        <RewardRow
                          value={formatNumber(pendingSushi?.toSignificant(6) ?? 0)}
                          symbol={reward.currency.symbol}
                        />
                      )}
                      {i === 1 && <RewardRow value={formatNumber(pendingReward)} symbol={reward.currency.symbol} />}
                    </>
                  ) : (
                    <RewardRow value={formatNumber(pendingReward)} symbol={reward.currency.symbol} />
                  )}
                </Box>
              )
            })}
          </Box>
          <Box className="enter_btn">
            <Button
              loading={pendingTx}
              disabled={
                pendingTx ||
                !((pendingSushi && pendingSushi.greaterThan(ZERO)) || (pendingReward && Number(pendingReward) > 0))
              }
              onClick={onHarvest}
            >
              {i18n._(t`Claim Rewards`)}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default InvestmentDetails
